export default {
  '001': 'Pay By Account',
  '002': 'Pay By New Credit Card',
  '004': 'Pay By Saved Credit Card'
};
